import React from "react";
import { motion } from "framer-motion";
import { ShoppingBag, ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const OFFERUP_URL = "https://offerup.com/p/45236131";

export default function OfferUp() {
  const { t } = useLanguage();
  return (
    <section
      data-testid="offerup-section"
      className="relative section-pad bg-[#0a0a0a]"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
          className="relative card-surface p-10 md:p-16 overflow-hidden"
        >
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.18),transparent_60%)]" />
          <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-7">
              <span className="text-overline">{t("offerup.overline")}</span>
              <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl mt-3 leading-tight">
                <span className="text-white">{t("offerup.title").split(" ").slice(0, 2).join(" ")} </span>
                <span className="gold-gradient-text italic">
                  {t("offerup.title").split(" ").slice(2).join(" ")}
                </span>
              </h2>
              <p className="mt-5 text-white/65 text-sm md:text-base max-w-xl leading-relaxed">
                {t("offerup.desc")}
              </p>
            </div>
            <div className="md:col-span-5 flex md:justify-end">
              <a
                href={OFFERUP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="offerup-cta"
                className="btn-gold"
              >
                <ShoppingBag size={16} strokeWidth={2} />
                {t("offerup.cta")}
                <ArrowUpRight size={14} />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
